module.exports = __webpack_public_path__ + "img/logo-cia-de-talentos.0552bfc3.png";